// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11fkw","main":"styles_main__12P4j"};